<template>
  <div class="pmp-field">
    <label v-if="label" class="pmp-form-label" :for="inputId">
      {{ label }}
    </label>

    <div
      class="pmp-input-shell pmp-input-shell--with-action"
      :class="{ 'is-error': error, 'has-value': modelValue }"
    >
      <input
        :id="inputId"
        ref="timeInputRef"
        class="pmp-input-control"
        type="time"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
      />

      <button
        type="button"
        class="pmp-input-action"
        aria-label="Seleccionar hora"
        @click="openNativePicker"
      >
        <i class="bi bi-clock" aria-hidden="true"></i>
      </button>
    </div>

    <p v-if="error && errorMessage" class="pmp-error-message">
      {{ errorMessage }}
    </p>

    <p v-else-if="helper" class="pmp-helper-text">
      {{ helper }}
    </p>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: undefined
  },
  label: {
    type: String,
    default: ''
  },
  helper: {
    type: String,
    default: ''
  },
  error: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: ''
  }
})

defineEmits(['update:modelValue', 'blur', 'focus'])

const timeInputRef = ref(null)
const inputId = props.id || `pmp-time-${Math.random().toString(36).slice(2)}`

function openNativePicker() {
  const picker = timeInputRef.value

  if (!picker) return

  if (typeof picker.showPicker === 'function') {
    picker.showPicker()
    return
  }

  picker.focus()
  picker.click()
}
</script>